import React, { useEffect, useState } from "react";

import { useTranslation } from "utils";

import { BLANK_PRACTICE } from "consts";

import { Icon, Link } from "components";

import { TillageSeedingForm } from "pages/app/modules/components/TillageSeeding/TillageSeedingForm";

export const TillageSeedingBaselineYear = ({ existingPractices, forms, tillageAndSeedings, year, onDeletePractice, onUpdate, dataTestId }) => {
  const { t } = useTranslation(["modules"]);
  const defaultPractices = existingPractices || [BLANK_PRACTICE()];
  const [practices, setPractices] = useState(defaultPractices);

  useEffect(() => {
    forms.current[year] = forms.current[year].slice(0, practices.length);
  }, [forms, practices, year]);

  const addNewPractice = () => {
    const updatedPractices = [...practices, BLANK_PRACTICE()];
    setPractices(updatedPractices);
    onUpdate("tillage_seeding", year, updatedPractices);
  };

  const deletePractice = (index) => {
    const practicesCopy = [...practices];
    practicesCopy.splice(index, 1);
    setPractices(practicesCopy);
    onDeletePractice("tillage_seeding", practices[index].id);
    onUpdate("tillage_seeding", year, practicesCopy);
  };

  const updatePractice = (index, v) => {
    const practicesCopy = [...practices];
    practicesCopy[index] = { id: practicesCopy[index].id, ...v };
    setPractices(practicesCopy);
    onUpdate("tillage_seeding", year, practicesCopy);
  };

  return (
    <div className="baseline-form margin-bottom-400">
      <div className="baseline-year-header-row">
        <h2>{year}</h2>
      </div>

      {practices.length ? (
        practices.map((practice, index) => (
          <div key={practice.id || practice.key}>
            <TillageSeedingForm
              dataTestId={dataTestId}
              tillageAndSeedings={tillageAndSeedings}
              forms={forms}
              index={index}
              practice={practice}
              year={year}
              onDelete={deletePractice}
              onUpdate={updatePractice}
            />
          </div>
        ))
      ) : (
        <p className="margin-bottom-200">{t("bauEntryDrawer.tillageAndSeeding.noneApplied")}</p>
      )}
      <div className="margin-bottom">
        <Link dataTestId="tillage-seeding-add-practice" onClick={addNewPractice}>
          {t("bauEntryDrawer.tillageAndSeeding.addPractice")} <Icon iconName="klim/plus" className="icon inline" />
        </Link>
      </div>
    </div>
  );
};
